import * as React from "react";
const SvgLineM = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 17V7", stroke: "white", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export { SvgLineM as ReactComponent };
